import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AUTH_STORE, AuthStore } from '../Store/Auth';
import { observer, inject } from 'mobx-react';

interface IProps extends RouteComponentProps<string> {
    [AUTH_STORE]: AuthStore;
}

@inject(AUTH_STORE)
@observer
export class SigninCallback extends React.Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

    componentDidMount = async () => {
      const authStore = this.props[AUTH_STORE];
      await authStore.signinRedirectCallback();
      this.props.history.replace('/');
    }

    render = () => (
      <div>logando</div>
    )
}